import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";

const getCMEditReasons = async (id) => {
	try {
		let response = await API.get(`${Apis.CMEditReasons}?siteAppId=${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

const patchCMEditReasons = async (id, requestData) => {
	try {
		let response = await API.patch(`${Apis.CMEditReasons}/${id}`, requestData);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

const addCMEditReasons = async (requestData) => {
	try {
		let response = await API.post(Apis.CMEditReasons, requestData);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export { getCMEditReasons, patchCMEditReasons, addCMEditReasons };
